import * as React from 'react'
import { components, ControlProps } from 'react-select'
import { HiddenOptionsCounter } from './multi-select.styles'
import { identifiers } from './multi-select.constants'
import { getStats } from './smart-control.utils'
import { OptionTypeBase } from '../../interface/optionTypeBase'

export interface SmartControlProps<OptionType extends OptionTypeBase>
  extends ControlProps<OptionType> {
  id: string
  optionGapInPx: number
  optionsContainerWidthInPx: number
  displayRows: number
}

export function SmartControl<OptionType extends OptionTypeBase>({
  id,
  optionGapInPx,
  optionsContainerWidthInPx,
  innerProps,
  displayRows,
  ...props
}: SmartControlProps<OptionType>) {
  const [itemsStats, updateStats] = React.useState(null)

  React.useLayoutEffect(() => {
    const stats = getStats(id, optionGapInPx, optionsContainerWidthInPx)

    updateStats({
      rowsNumber: stats.rowsNumber + 1,
      itemsInRow: stats.itemsInRow,
      hiddenItemsCount:
        stats.itemsInRow.length > displayRows
          ? stats.itemsInRow
              .slice(displayRows)
              .reduce((total: number, num: number) => total + num)
          : 0,
    })
  }, [id, optionGapInPx, optionsContainerWidthInPx, props.selectProps.value])

  return (
    <components.Control
      {...props}
      innerProps={
        {
          ...innerProps,
          'data-id': `${id}__${identifiers.control}`,
        } as any
      }
    >
      {props.children}
      {!props.selectProps.menuIsOpen &&
        itemsStats &&
        itemsStats.hiddenItemsCount > 0 && (
          <HiddenOptionsCounter id="hidden-opts-number">
            +{itemsStats.hiddenItemsCount}
          </HiddenOptionsCounter>
        )}
    </components.Control>
  )
}
